import {useNavigate, useParams} from "react-router-dom";
import valuer_api from "../api/valuer";
import template_api from "../api/template";
import {useEffect, useState} from "react";
import GenericDialog from "../components/GenericDialog";
import ValuerAmendHeader from "../components/valuer/ValuerAmendHeader";
import ValuerAmendSideBar from "../components/valuer/ValuerAmendSideBar";
import textUtils from "../utils/TextUtils";
import dateUtils from "../utils/DateUtils";
import ValuerAmendAccordion from "../components/valuer/ValuerAmendAccordion";
import ButtonLoadingWheel from "../components/ButtonLoadingWheel";
import val_api from "../api/valuation";
import address_formatter from "../utils/Address";
import ValuerAmendClientData from "../components/valuer/ValuerAmendClientData";



const ValuerAmend = () => {
    const params = useParams();
    const valuation_id = params.valuation_id;
    const template_id = params.template_id;
    const navigate = useNavigate();

    const [report, setReport] = useState();
    const [summaryId, setSummaryId] = useState();

    // Header Fields
    const [savingQueue, setSavingQueue] = useState([]);
    const [savedTimestamps, setSavedTimestamps] = useState([]);
    const [erroredSaves, setErroredSaves] = useState([]);

    const [reportAddress, setReportAddress] = useState("");

    const [processing, setProcessing] = useState(false)

    const [values, setValues] = useState({});

    const [reportFields, setReportFields] = useState([]);

    // Error Popup
    const [errorMessage, setErrorMessage] = useState("");
    const [errorTitle, setErrorTitle] = useState("");
    const okButton = [{"text":"OK", "id": "1"}];
    const resetErrorMessage = () => {
        setErrorMessage("");
        setErrorTitle("");
    }

    useEffect(() => {
        if (!valuation_id) return
        getReport()
    }, [])

    useEffect(() => {
        if (!summaryId) return
        getReportFieldsById()
    }, [summaryId]);

    const getReport = () => {
        if (!valuation_id) return;
        let response = valuer_api.getReport(valuation_id);
        response.then(
            response => {
                setReport(response.data);
                setSummaryId(response.data.summary_id)
                if (response.data && response.data.address && response.data.postcode)
                    setReportAddress(textUtils.toTitleCase(response.data.address) + ", " + response.data.postcode)
                else {
                    setErrorTitle("Valuation Request Error")
                    setErrorMessage("There was an error getting the address of the Valuation Request - Please Try Again")
                }
            }
        ).catch(() => {
            setErrorTitle("Valuation Request Error")
            setErrorMessage("There was an error getting the Valuation Request - Please Try Again")
        })
    }

    const getReportFieldsById = () => {
        if (!template_id) return
        template_api.getTemplateUIById(template_id, summaryId)
            .then(response => {setReportFields(response.data.sections)
            })
            .catch(() => {
                setErrorTitle("Template Error")
                setErrorMessage("There was an error getting the template UI - Please Try Again")
            })
    }


    const saveAll = () => {
        console.log("save all");
    }

    const AddToQueue = (section, identifier, _timestamp) => {
        if (!section || !identifier || !_timestamp) return;
        setSavingQueue(sq => {
            return [...sq, {
                "section": section,
                "field": identifier,
                "timestamp": _timestamp
            }]
        })
    }

    const RemoveFromQueue = (section, identifier, _timestamp) => {
        setSavingQueue(sq => {
            let list = [...sq]
            for (let i = 0; i < list.length; i++) {
                if (list[i].section === section && list[i].field === identifier && list[i].timestamp === _timestamp) {
                    list.splice(i, 1);
                }
            }
            return list
        })
        setSavedTimestamps(st => {
            return [...st, _timestamp];
        })
    }

    const AddToErroredSaves = (section, identifier, _timestamp) => {
        setErroredSaves(es => {
            let es_copy = [...es]
            es_copy.push({
                "section": section,
                "field": identifier,
                "timestamp": _timestamp
            })
            return es_copy
        })
        setSavingQueue(sq => {
            let list = [...sq]
            for (let i = 0; i < list.length; i++) {
                if (list[i].section === section && list[i].field === identifier && list[i].timestamp === _timestamp) {
                    list.splice(i, 1);
                }
            }
            return list
        })
    }

    const handleAmendClick = () => {
        if (!report || !summaryId) return

        let response = val_api.SaveToPDF(summaryId, { template_id: parseInt(template_id) });
        response.then(() => {
            setProcessing(false)
            navigate("/valuer/review/" + valuation_id);
        }).catch(err => {
            getReport()
            setProcessing(false)
            setErrorTitle("Failed to Save PDF")
            setErrorMessage(err.response.data.description);
        })
    }

    const UpdateGrandparentValue = (identifier, value) => {
        setValues(v => {
            let v_copy = Object.assign({}, v)
            v_copy[identifier] = value
            return v_copy
        })
    }

    const GetValueFromGrandParentValues = (identifier) => {
        return values[identifier]
    }

    return (
        <div className="valuer-amend-page-container">
            <ValuerAmendHeader valuationId={valuation_id}
                               savingQueue={savingQueue}
                               savedTimestamps={savedTimestamps}
                               erroredSaves={erroredSaves}
                               address={reportAddress}
                               saveAll={saveAll.bind(this)}
            />
            <div className="valuer-amend-form-container">
                <ValuerAmendSideBar requestType={report && report.manual_addition ? "Manual address" : "Database address"}
                                    valuation={report && "£" + report.valuation.toLocaleString()}
                                    requestTime={report && dateUtils.display_date_time(report.review_initiated_date * 1000)}
                                    request={report && report.request}
                                    summaryStatusId={report && report.summary_status_id}
                                    currentStatusId={report && report.current_status_id}
                                    currentValuerId={report && report.valuer_id}
                                    reportId={report && report.id}
                                    setErrorMessage={setErrorMessage}
                                    setErrorTitle={setErrorTitle}
                                    requestId={valuation_id}
                />
                <div className="valuer-amend-form-content-container">
                    <ValuerAmendClientData setErrorMessage={setErrorMessage}
                                           setErrorTitle={setErrorTitle}
                                           AddToQueue={AddToQueue}
                                           RemoveFromQueue={RemoveFromQueue}
                                           AddToErroredSaves={AddToErroredSaves}
                                           summaryId={summaryId}
                                           csvFilename={report && address_formatter.getFileName(report, '.csv')}
                    />
                    {reportFields && reportFields.map((section, idx) => {
                        return <ValuerAmendAccordion key={idx}
                                                     enabled={!!(report && report.summary_id)}
                                                     hasCard={section.card}
                                                     sectionName={section.heading}
                                                     identifier={section.identifier}
                                                     fieldList={section.fields}
                                                     summaryId={report && report.summary_id}
                                                     setErrorMessage={setErrorMessage}
                                                     setErrorTitle={setErrorTitle}
                                                     AddToQueue={AddToQueue}
                                                     RemoveFromQueue={RemoveFromQueue}
                                                     AddToErroredSaves={AddToErroredSaves}
                                                     UpdateGrandparentValue={UpdateGrandparentValue}
                                                     GetValueFromGrandParentValues={GetValueFromGrandParentValues}
                        />
                    })}
                    <div className="valuer-amend-button-container">
                        <button className={processing ? "valuation-amend-save-button" : "valuation-amend-save-button link"}
                                onClick={() => handleAmendClick()} disabled={processing}>
                            {processing ?
                                <div className="valuer-submit-container">
                                    <ButtonLoadingWheel show={processing}/>
                                </div>
                                :
                                <>Save to PDF</>
                            }
                        </button>
                    </div>
                </div>
            </div>
            {errorMessage && errorTitle ?
                <GenericDialog title={errorTitle} text={errorMessage} buttons={okButton}
                               result={() => resetErrorMessage()}/>
                : null
            }
        </div>
    )
}

export default ValuerAmend